window.addEventListener("resize", setSize, false);
window.addEventListener("orientationchange", setSize, false);
let screenHeight = document.body.offsetHeight
function setSize() {
    var html = document.getElementsByTagName('html')[0];
    var width = html.clientWidth;
    var height = html.clientHeight;
    var ratio = width / height;
    if (ratio > 0.8) {
        html.style.fontSize = width / 18 + "px";
    } else if (ratio > 0.69) {
        html.style.fontSize = width / 19.8 + "px";
    } else if (ratio > 0.67) {
        html.style.fontSize = width / 19.6 + "px";
    } else if (ratio > 0.65) {
        html.style.fontSize = width / 19.2 + "px";
    } else if (ratio > 0.60) {
        html.style.fontSize = width / 18 + "px";
    } else if (ratio > 0.55) {
        html.style.fontSize = width / 17 + "px";
    } else {
        html.style.fontSize = width / 18 + "px";
    }
    MobileInput();
}
var IsAndroid=function(){
    var u = navigator.userAgent, app = navigator.appVersion;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
    return isAndroid;
}
//解决页面在不同设备上面的输入问题
function MobileInput() {
    if(IsAndroid()){
        var thisHeight = document.body.offsetHeight;
        if (screenHeight - thisHeight > 5) {
            //当软键盘弹出，在这里面操作
            document.body.style = "height:" + screenHeight + "px";
            document.getElementById('app').style = "margin-top:-100px";
        } else {
            //alert('bbb');
            //当软键盘收起，在此处操作
            document.body.style = "height:100%";
            document.getElementById('app').style = "";
        } 
    }
    
    // if (document.activeElement.tagName == 'INPUT') {
    //     //延迟出现是因为有些 Android 手机键盘出现的比较慢  
    //     let nowHeight = document.body.offsetHeight
    //     if (nowHeight < screenHeight) {
    //         // 将底部弹起的按钮隐藏（可使用给按钮添加相应消失类）
    //         //alert(screenHeight-nowHeight-240);
    //         document.getElementById('app').style = "margin-top:" + (screenHeight - nowHeight - 240) + "px";
    //     } else {
    //         // 将按钮正常显示（可使用给按钮移除相应消失类）
    //         document.getElementById('app').style = "";
    //     }
    // }
}
setSize();